import { BatchesList } from '../components/batches/BatchesList';
import { UnpostedBatchesList } from '../components/batches/UnpostedBatchesList';
import { ShelvedBatchesList } from '../views/batches/ShelvedBatchesList';
import { ROUTES } from './routesEnums';

export enum BATCHES_TABS {
  BATCHES = 'posted',
  UNPOSTED_BATCHES = 'unposted',
  SHELVED_BATCHES = 'shelved',
}

export const BATCHES_BASE_URL = `${ROUTES.FUNDS}${ROUTES.BATCHES}`;

export const batchesRoutes = [
  {
    key: BATCHES_TABS.UNPOSTED_BATCHES,
    pathname: `${BATCHES_BASE_URL}/${BATCHES_TABS.UNPOSTED_BATCHES}`,
    component: <UnpostedBatchesList />
  },
  {
    key: BATCHES_TABS.BATCHES,
    pathname: `${BATCHES_BASE_URL}/${BATCHES_TABS.BATCHES}`,
    component: <BatchesList />
  },
  {
    key: BATCHES_TABS.SHELVED_BATCHES,
    pathname: `${BATCHES_BASE_URL}/${BATCHES_TABS.SHELVED_BATCHES}`,
    component: <ShelvedBatchesList />
  },
];

export const getInitialBatchesNavTab = (pageName: string): BATCHES_TABS => {
  switch (pageName) {
    case `${BATCHES_BASE_URL}/${BATCHES_TABS.UNPOSTED_BATCHES}`:
      return BATCHES_TABS.UNPOSTED_BATCHES;
    case `${BATCHES_BASE_URL}/${BATCHES_TABS.BATCHES}`:
      return BATCHES_TABS.BATCHES;
    case `${BATCHES_BASE_URL}/${BATCHES_TABS.SHELVED_BATCHES}`:
      return BATCHES_TABS.SHELVED_BATCHES;
    default:
      return BATCHES_TABS.UNPOSTED_BATCHES;
  }
};